/**
 * Liquid Ajax Cart Initialization
 * https://liquid-ajax-cart.js.org/
 */

(function() {
    'use strict';
  
    // Configuration for Liquid Ajax Cart
    if (typeof liquidAjaxCart !== 'undefined') {
      liquidAjaxCart.conf('updateOnWindowFocus', true);
      liquidAjaxCart.conf('addToCartCssClass', 'js-ajax-add-to-cart');
      liquidAjaxCart.conf('binderAttribute', 'data-ajax-cart-bind');
      
      // Custom request processor for better error handling
      liquidAjaxCart.conf('requestBodyClass', 'ajax-cart-request-in-progress');
      
      document.addEventListener('liquid-ajax-cart:request-end', function(event) {
        const { requestState } = event.detail;

        if (!requestState.responseData?.ok) {
          console.error('❌ Cart request failed:', requestState);
          return;
        }

        if (requestState.requestType === 'add') {
          if (window.refreshCartDrawer) window.refreshCartDrawer();
          // Meta Pixel: AddToCart
          if (typeof fbq !== 'undefined') {
            fbq('track', 'AddToCart', {
              content_type: 'product',
              currency: window.Shopify?.currency?.active || 'USD'
            });
          }
        } else {
          requestState.responseData.json().then(function(data) {
            if (data.item_count !== undefined) updateCartCount(data.item_count);
          }).catch(function(err) {
            console.error('Cart response parse error:', err);
          });
        }
      });

      // Update cart count when quantity is changed via form inputs
      document.addEventListener('change', function(e) {
        if (e.target.matches('.js-qty__num, [name="updates[]"]')) {
          // Delay to allow cart update to process
          setTimeout(function() {
            fetch('/cart.js')
              .then(response => response.json())
              .then(function(cart) {
                updateCartCount(cart.item_count);
              })
              .catch(function(error) {
                console.error('Error updating cart count:', error);
              });
          }, 300);
        }
      });

      // Update cart count when quantity buttons are clicked
      document.addEventListener('click', function(e) {
        if (e.target.closest('.cart-item__qty-btn, .cart-item__qty-plus, .cart-item__qty-minus')) {
          // Delay to allow cart update to process
          setTimeout(function() {
            fetch('/cart.js')
              .then(response => response.json())
              .then(function(cart) {
                updateCartCount(cart.item_count);
              })
              .catch(function(error) {
                console.error('Error updating cart count:', error);
              });
          }, 500); // Slightly longer delay for button clicks
        }
      });

      // Update cart count when AJAX cart form is submitted
      document.addEventListener('submit', function(e) {
        if (e.target.matches('.ajaxcart')) {
          // Delay to allow cart update to process
          setTimeout(function() {
            fetch('/cart.js')
              .then(response => response.json())
              .then(function(cart) {
                updateCartCount(cart.item_count);
              })
              .catch(function(error) {
                console.error('Error updating cart count:', error);
              });
          }, 300);
        }
      });
  
      // Listen for errors
      document.addEventListener('liquid-ajax-cart:request-end', function(event) {
        const { requestState } = event.detail;
        
        if (requestState.responseData && !requestState.responseData.ok) {
          requestState.responseData.json().then(function(errorData) {
            console.error('Cart error:', errorData);
            if (errorData.description) {
              showCartError(errorData.description);
            }
          }).catch(function() {
            showCartError('An error occurred. Please try again.');
          });
        }
      });
    }
  
    function getCartCountFromDrawerTitle() {
      var el = document.querySelector('#AjaxCartDrawer .drawer__title');
      if (!el || !el.textContent) return undefined;
      var m = /\((\d+)\)/.exec(el.textContent);
      return m ? parseInt(m[1], 10) : undefined;
    }

    function updateCartCount(count) {
      const cartCountElements = document.querySelectorAll('.cart-count, .cart-link__bubble, [data-cart-count]');
      cartCountElements.forEach(function(el) {
        if (el.classList.contains('cart-link__bubble')) {
          if (count > 0) {
            el.classList.add('cart-link__bubble--visible');
            el.textContent = count;
          } else {
            el.classList.remove('cart-link__bubble--visible');
            el.textContent = '';
          }
        } else if (el.hasAttribute('data-cart-count')) {
          el.setAttribute('data-cart-count', count);
          el.textContent = count;
        } else {
          el.textContent = count;
        }
      });
    }
  
    // Show error message
    function showCartError(message) {
      // Create or use existing error container
      let errorContainer = document.querySelector('.cart-error-toast');
      
      if (!errorContainer) {
        errorContainer = document.createElement('div');
        errorContainer.className = 'cart-error-toast';
        document.body.appendChild(errorContainer);
      }
  
      errorContainer.textContent = message;
      errorContainer.classList.add('cart-error-toast--visible');
  
      setTimeout(function() {
        errorContainer.classList.remove('cart-error-toast--visible');
      }, 4000);
    }
  
    // Refresh cart drawer content
    // Use the function from ajax-cart-drawer.liquid if available, otherwise create our own
    if (!window.refreshCartDrawer) {
      window.refreshCartDrawer = function() {
        const drawer = document.getElementById('AjaxCartDrawer');
        if (!drawer) return Promise.resolve();
        
        return fetch('/?section_id=ajax-cart-drawer')
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('#AjaxCartDrawer');
            const currentDrawer = document.querySelector('#AjaxCartDrawer');
            
            if (newDrawer && currentDrawer) {
              const isOpen = currentDrawer.classList.contains('drawer--is-open');
              currentDrawer.innerHTML = newDrawer.innerHTML;
              
              if (isOpen) {
                currentDrawer.classList.add('drawer--is-open');
              }
              
              // Re-initialize inline scripts only
              const scripts = newDrawer.querySelectorAll('script');
              scripts.forEach(oldScript => {
                if (!oldScript.src && oldScript.innerHTML.trim()) {
                  try {
                    const newScript = document.createElement('script');
                    Array.from(oldScript.attributes).forEach(attr => {
                      newScript.setAttribute(attr.name, attr.value);
                    });
                    newScript.textContent = oldScript.innerHTML;
                    currentDrawer.appendChild(newScript);
                    setTimeout(() => newScript.remove(), 0);
                  } catch (error) {
                    console.error('Error executing script:', error);
                  }
                }
              });
            }
          })
          .catch(error => {
            console.error('Error refreshing cart drawer:', error);
          });
      };
    }

    // Helper to open cart drawer with refresh
    window.openCartDrawer = function(shouldRefresh = true) {
      const drawer = document.getElementById('AjaxCartDrawer');
      if (drawer) {
        if (shouldRefresh) {
          // Refresh cart before opening
          window.refreshCartDrawer().then(() => {
            drawer.classList.add('drawer--is-open');
            document.documentElement.classList.add('js-drawer-open', 'js-cart-drawer-open');
            document.body.style.overflow = 'hidden';
          });
        } else {
          drawer.classList.add('drawer--is-open');
          document.documentElement.classList.add('js-drawer-open', 'js-cart-drawer-open');
          document.body.style.overflow = 'hidden';
        }
      }
    };
  
    // Helper to close cart drawer
    window.closeCartDrawer = function() {
      const drawer = document.getElementById('AjaxCartDrawer');
      if (drawer) {
        drawer.classList.remove('drawer--is-open');
        document.documentElement.classList.remove('js-drawer-open', 'js-cart-drawer-open');
        document.body.style.overflow = '';
      }
    };
  
    // Initialize grauxCart global (single source for cart count updates)
    if (!window.grauxCart) {
      window.grauxCart = {
        open: window.openCartDrawer,
        close: window.closeCartDrawer,
        updateCartCount: updateCartCount
      };
    } else {
      window.grauxCart.updateCartCount = updateCartCount;
    }
  
    // Make cart icon open drawer - use capturing phase to intercept early
    document.addEventListener('click', function(e) {
      // Check if click is on cart link
      const cartLink = e.target.closest('.js-drawer-open-cart');
      const cartHref = e.target.closest('a[href="/cart"]');
      
      if (cartLink || cartHref) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        window.openCartDrawer();
        return false;
      }

      if (!e.target.closest('#AjaxCartDrawer') && document.querySelector('#AjaxCartDrawer.drawer--is-open')){
        window.closeCartDrawer();
        return false;
      }
    }, true); // Use capturing phase

    // Cart Terms Agreement Logic
    // Support for both static cart (ajax-cart-drawer) and AJAX cart (ajax-cart-template)
    const checkboxSelectors = [
      '#cart-terms-checkbox',           // Static cart drawer
      '.cart-terms-checkbox input[type="checkbox"]'  // AJAX cart template
    ];

    const buttonSelectors = [
      '#cart-checkout-btn',             // Static cart drawer
      '#ajax-cart-checkout-btn'         // AJAX cart template
    ];

    function findCheckbox() {
      for (const selector of checkboxSelectors) {
        const checkbox = document.querySelector(selector);
        if (checkbox) return checkbox;
      }
      return null;
    }

    function findCheckoutButton() {
      for (const selector of buttonSelectors) {
        const button = document.querySelector(selector);
        if (button) return button;
      }
      return null;
    }

    function initTermsLogic() {
      const termsCheckbox = findCheckbox();
      const checkoutBtn = findCheckoutButton();

      if (!termsCheckbox || !checkoutBtn) {
        // Elements not found yet, try again later
        setTimeout(initTermsLogic, 100);
        return;
      }

      // Disable checkout button initially
      checkoutBtn.disabled = true;

      // Handle checkbox change
      termsCheckbox.addEventListener('change', function() {
        checkoutBtn.disabled = !this.checked;
      });

      // If checkbox is already checked (e.g., from previous state), enable button
      if (termsCheckbox.checked) {
        checkoutBtn.disabled = false;
      }
    }

    // Initialize immediately if DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTermsLogic);
    } else {
      initTermsLogic();
    }

    // Also watch for dynamic content changes (for AJAX cart updates)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          const checkbox = findCheckbox();
          const button = findCheckoutButton();

          if (checkbox && button && !button.hasAttribute('data-terms-initialized')) {
            button.setAttribute('data-terms-initialized', 'true');

            // Disable checkout button initially
            button.disabled = true;

            // Handle checkbox change
            checkbox.addEventListener('change', function() {
              button.disabled = !this.checked;
            });

            // If checkbox is already checked, enable button
            if (checkbox.checked) {
              button.disabled = false;
            }
          }
        }
      });
    });

    // Observe changes in the cart containers
    const cartContainers = [
      document.querySelector('.drawer__content'),
      document.getElementById('CartDrawer'),
      document.getElementById('CartContainer'),
      document.querySelector('.ajax-cart-drawer')
    ];

    cartContainers.forEach(container => {
      if (container) {
        observer.observe(container, {
          childList: true,
          subtree: true
        });
      }
    });

    // Periodically check for cart updates and re-initialize if needed
    setInterval(function() {
      const checkbox = findCheckbox();
      const button = findCheckoutButton();

      if (checkbox && button && !button.hasAttribute('data-terms-initialized')) {
        initTermsLogic();
      }
    }, 500);

    // Initialize cart count on page load
    fetch('/cart.js')
      .then(response => response.json())
      .then(function(cart) {
        updateCartCount(cart.item_count);
      })
      .catch(function(error) {
        console.error('Error initializing cart count:', error);
      });

    console.log('🛒 Liquid Ajax Cart initialized');
    console.log('📝 Terms Agreement Logic initialized');
  })();
  